import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Play, BookOpen } from "lucide-react";
import api from "@/lib/api";

export default function MyCoursesPage() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/my-courses")
      .then((r) => setCourses(r.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-with-nav bg-white min-h-screen" data-testid="my-courses-page">
      <div className="px-4 pt-4 pb-2">
        <h1 className="text-xl font-black text-slate-900" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          My Courses
        </h1>
        <p className="text-xs text-slate-500 mt-0.5">{courses.length} purchased</p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-slate-400">Loading...</div>
      ) : courses.length === 0 ? (
        <div className="text-center py-16 px-6">
          <BookOpen size={48} className="mx-auto text-slate-300 mb-4" />
          <p className="text-sm text-slate-500 mb-4">You haven't purchased any courses yet.</p>
          <button
            data-testid="browse-courses-btn"
            onClick={() => navigate("/courses")}
            className="bg-[#0284C7] text-white font-bold py-3 px-6 text-sm transition-none"
          >
            Browse Courses
          </button>
        </div>
      ) : (
        <div className="px-4 pb-4 space-y-3" data-testid="my-courses-list">
          {courses.map((course) => (
            <div
              key={course.id}
              data-testid={`my-course-${course.id}`}
              className="flex gap-3 bg-slate-50 cursor-pointer"
              onClick={() => navigate(`/watch/${course.id}`)}
            >
              <div className="w-32 flex-shrink-0 aspect-video bg-slate-200">
                <img
                  src={course.image_url || "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=300&h=170&fit=crop"}
                  alt={course.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 py-2 pr-3 flex flex-col justify-between">
                <div>
                  <p className="text-[10px] font-bold uppercase text-[#0284C7]">{course.category}</p>
                  <h3 className="text-sm font-bold text-slate-900 line-clamp-2">{course.title}</h3>
                </div>
                <div className="flex items-center gap-1 text-[#0284C7]">
                  <Play size={14} />
                  <span className="text-xs font-bold">
                    {course.content_type === "book" ? "Read" : "Continue"}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
